/**
 * Must match `@pncl/models` `AlertStatus`
 * (`packages/models` cannot import `@pncl/common-models`).
 */
export enum AlertStatus {
  OPEN = 'OPEN',
  ASSIGNED = 'ASSIGNED',
  CLOSED = 'CLOSED'
}

/** Unassigned (`OPEN`) or in progress (`ASSIGNED`). */
export const UNRESOLVED_ALERT_STATUSES = [
  AlertStatus.OPEN,
  AlertStatus.ASSIGNED
];
